export default "__VITE_ASSET__DtY0psCJ__"